import React from 'react';
import './loader.css';

export default () => <div className="lds-dual-ring" />
